/**
 * 商品ページのバリデーション
 * バリデーションの対応
 * - 'pattern-select': 色柄選択 - 指定数の色柄を選択しているか
 * - 'hanakomon': 花個紋選択 - 日付と色を選択しているか
 * - 'embroidery': 刺繍 - 刺繍文字、刺繍色を選択しているか
 */

// 各項目ごとのバリデーション関数
function validatePatternSelect() {
  const designType = document.querySelector(
    'input[name="properties[デザイン]"]'
  );
  if (!designType) return false;
  const designTypeValue = designType.value;
  const patternNum =
    designTypeValue === "ワンカラー" || designTypeValue === "1色" ? 1 : 2;
  const patterns = document.querySelectorAll('input[name^="properties[柄"');
  if (patterns.length !== patternNum) return false;
  return true;
}

function validatePatternSelectMulti() {
  const patternSelecter = document.getElementById('product-pattern-selecter');
  if (!patternSelecter) return false;
  const validate = patternSelecter.dataset.validate;
  if (validate === "false") return false;
  return true;
}

function validateHanakomon(property) {
  if (!property) return false;
  if (property.date == "" || property.color == "") return false;
  if (
    property.target == ""
  )
    return false;
  return true;
}

function validateOptionHanakomon(property) {
  if (!property) return false;
  if (property.date == "" || property.color == "") return false;
  return true;
}

function validateEmbroidery(property) {
  if (!property) return false;
  if (property.text == "") return false;
  if (property.text.length == 0 || property.text.length > 40) return false;
  if (property.color == "") return false;
  if (
    property.target == ""
  )
    return false;
  return true;
}

function validateOptionEmbroidery(property) {
  if (!property) return false;
  if (property.text == "") return false;
  if (property.text.length == 0 || property.text.length > 40) return false;
  return true;
}

function validateGiftWrapping(property) {
  if (property === null) return false;
  if (property.wrapping === "あり") {
    if (property.wrappingPaper == "") return false;
    if (property.noshi !== null) {
      if (property.omoteGaki == "") return false;
    }
    if (property.wrappingItems.length === 0) return false;
  }
  if (property.messageCard === "あり") {
    if (property.messageCardText == "") return false;
  }
  if (property.historyMemo === "あり") {
    if (property.historyMemoData.historyName == "") return false;
    if (property.historyMemoData.birthday == "") return false;
  }
  return true;
}

function validateAshigata() {
  const text = document.querySelector('input[name="properties[刺繍文字]"]');
  if (!text) return false;
  if (text.value == "" || text.value.length > 10) return false;
  const target = document.querySelector(
    'input[name="properties[刺繍を入れる柄]"]'
  );
  if (!target) return false;
  if (target.value == "") return false;
  const color = document.querySelector('input[name="properties[刺繍の色]"]');
  if (!color) return false;
  if (color.value == "") return false;
  return true;
}

// 項目名とバリデーション関数のマッピング
const VALIDATION_FUNCTIONS = {
  "pattern-select": validatePatternSelect,
  "pattern-select-multi": validatePatternSelectMulti,
  hanakomon: validateHanakomon,
  embroidery: validateEmbroidery,
  optionHanakomon: validateOptionHanakomon,
  optionEmbroidery: validateOptionEmbroidery,
  "gift-wrapping": validateGiftWrapping,
  ashigata: validateAshigata,
};

// 全てのバリデーションを順番にチェックする関数
function validateAll(properties = {}) {
  console.log("validateAll - properties", PRODUCT_VALIDATION_LIST);
  for (const key of PRODUCT_VALIDATION_LIST) {
    const validateFn = VALIDATION_FUNCTIONS[key];
    const property = properties[key] || null;
    console.log(
      "validateAll - property",
      key,
      property,
      validateFn(property),
    );
    if (validateFn && !validateFn(property)) {
      return false;
    }
  }
  return true;
}

// チェック結果に応じてカートボタンをdisableにする関数
function updateCartButtonState(properties = {}) {
  const cartButtons = document.querySelectorAll(
    ".product--add-to-cart-button, .shopify-payment-button__button"
  );
  if (!cartButtons) return;
  setTimeout(() => {
    console.log("updateCartButtonState - validateAll", validateAll(properties));
    if (validateAll(properties)) {
      cartButtons.forEach((button) => {
        button.disabled = false;
      });
    } else {
      cartButtons.forEach((button) => {
        button.disabled = true;
      });
    }
  }, 500);
}

// 入力値が変わったときにバリデーションを実行
function setupValidationListeners() {
  console.log("setupValidationListeners - PRODUCT_VALIDATION_LIST", PRODUCT_VALIDATION_LIST);
  PRODUCT_VALIDATION_LIST.forEach((key) => {
    let selector = "";
    if (key === "quantity") selector = 'input[name="quantity"]';
    if (key === "customOption") selector = 'input[name="customOption"]';
    // 必要に応じて追加
    if (selector) {
      const input = document.querySelector(selector);
      if (input) {
        input.addEventListener("input", updateCartButtonState);
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  setupValidationListeners();
  updateCartButtonState();
});
